import { IGetAllOrdemCompraPrecosUseCase } from "../../../presentation/useCases/read/get_all_ordem_compra_precos_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { OrdemCompraPreco } from "../../models/ordem_compra_preco";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllOrdemCompraPrecosUseCase
 */

export class GetAllOrdemCompraPrecosUseCase
  extends BasePaginatedUseCase<OrdemCompraPreco>
  implements IGetAllOrdemCompraPrecosUseCase {
  constructor(private readonly repository: IComprasRepository) {
    super();
  }

  async getAllOrdemCompraPrecos(
    centroCustos: number[] | null,
    titulo: string | null,
    fornecedores: number[] | null,
    dataOrdemCompraDe: Date | null,
    dataOrdemCompraAte: Date | null,
    ordemCompras: number[] | null,
    produtosServicos: number[] | null,
    dataPagoDe: Date | null,
    dataPagoAte: Date | null,
    subcontas: number[] | null,
    statusOC: number[] | null,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository.getAllOrdemCompraPrecos(
      centroCustos,
      titulo,
      fornecedores,
      dataOrdemCompraDe,
      dataOrdemCompraAte,
      ordemCompras,
      produtosServicos,
      dataPagoDe,
      dataPagoAte,
      subcontas,
      statusOC,
      page,
      rowsPerPage,
    );

    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
